import React, { createContext, useContext, useState, useCallback } from "react";

const QuotePopupContext = createContext({
  open: false,
  openPopup: () => {},
  closePopup: () => {},
});

export const QuotePopupProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openPopup = useCallback(() => setOpen(true), []);
  const closePopup = useCallback(() => setOpen(false), []);

  return (
    <QuotePopupContext.Provider value={{ open, openPopup, closePopup }}>
      {children}
    </QuotePopupContext.Provider>
  );
};

export const useQuotePopup = () => useContext(QuotePopupContext);
